export const getProducts = (state) => state.products
export const getProductTypes = (state) => state.types
export const getProductStatuses = (state) => state.statuses
export const getProductPricingType = (state) => state.pricing_types
export const getProductOverTime = (state) => state.over_time
